import supabase from "./supabase";

export interface EditClassParams {
  id: string;
  name: string;
  description?: string;
  createJoinCode: boolean;
  settings: {
    class_time: string;
    reflection_requirements?: {
      min_words?: number;
      min_sentences?: number;
      enabled: boolean;
    };
  };
  semester: string;
  grade_type: string;
}

export interface EditClassResponse {
  message: string;
  join_code: string | null;
  error?: string;
}

export async function editClass(
  params: EditClassParams
): Promise<EditClassResponse> {
  try {
    const { data, error } = await supabase.functions.invoke("editClass", {
      body: params,
    });

    if (error) {
      console.error("Error editing class:", error);
      return { message: "", join_code: null, error: error.message };
    }

    return data as EditClassResponse;
  } catch (error: any) {
    console.error("Error editing class:", error);
    return {
      message: "",
      join_code: null,
      error: error.message || "Failed to edit class",
    };
  }
}

export async function editClassPlatform(
  classId: string,
  platformName: string
): Promise<{ error: string | null }> {
  try {
    const { error } = await supabase
      .from("classes")
      .update({ platform: platformName })
      .eq("id", classId);

    if (error) {
      console.error("Error updating class:", error);
      return { error: error.message };
    }

    return { error: null };
  } catch (err: any) {
    console.error("Error updating class:", err);
    return { error: err.message };
  }
}
